import React from 'react'
import {useTranslation} from 'react-i18next'

import {ActionRowPaymentMethod} from 'src/products/loans/MakePayment/LoanPayConfirm/ActionRow/PaymentMethodActionRow.types'
import {formatMaskNonBreaking} from 'src/lib/user/utils'
import {LinkedAccountType} from '@possible/cassandra/src/types/types.mobile.generated'
import {NamedColors} from 'src/designSystem/colors'
import {PFStatusPillProps} from 'src/designSystem/components/atoms/PFStatusPill/PFStatusPill'
import {
  ActionRow,
  ActionRowProps,
} from 'src/products/loans/MakePayment/LoanPayConfirm/ActionRow/ActionRow'
import {
  getPaymentMethodFriendlyName,
  getPaymentMethodMask,
} from 'src/products/loans/MakePayment/LoanPay.utils'

type PaymentMethodActionRowProps = Partial<ActionRowProps> & {
  paymentMethod: ActionRowPaymentMethod
  onPressViewPaymentMethods?: () => void
  isDisabled?: boolean
  testID?: string
}

const PaymentMethodActionRow = (props: PaymentMethodActionRowProps): JSX.Element => {
  const {isDisabled = false, onPressViewPaymentMethods, paymentMethod, testID} = props
  const {t} = useTranslation('MakePaymentConfirm')

  const handleOnPress = (): void => {
    onPressViewPaymentMethods?.()
  }

  let titleStatusPill: PFStatusPillProps | undefined
  if (paymentMethod?.isPaymentMethodNew === true) {
    titleStatusPill = {
      text: t('NewAccount'),
      color: NamedColors.PRODUCT_BLUE,
      variant: 'outline',
      shape: 'rectangle',
      testID: 'StatusPill-New-Account',
    }
  }

  const friendlyName = getPaymentMethodFriendlyName(paymentMethod)
  const accountMask = getPaymentMethodMask(paymentMethod)
  const accountMaskWithPrefix = formatMaskNonBreaking(accountMask, false)
  const achAccountType: LinkedAccountType | undefined =
    paymentMethod.__typename === 'AchPaymentMethod' ? paymentMethod.account?.type : undefined

  const getAchAccountTypeText = (accountType: LinkedAccountType | undefined): string => {
    if (accountType === LinkedAccountType.Checking) {
      return t('Checking')
    }
    if (accountType === LinkedAccountType.Savings) {
      return t('Savings')
    }
    return ''
  }

  switch (paymentMethod.__typename) {
    case 'AchPaymentMethod':
      return (
        <ActionRow
          isDisabled={isDisabled}
          onPress={handleOnPress}
          subTitle={`${getAchAccountTypeText(achAccountType)}  ${accountMaskWithPrefix}`}
          testID={testID ?? 'payment-method-action-row-ach'}
          title={friendlyName ?? t('BankAccount')}
          titleStatusPill={titleStatusPill}
        />
      )
    case 'DebitCardPaymentMethod':
      return (
        <ActionRow
          isDisabled={isDisabled}
          onPress={handleOnPress}
          subTitle={`${t('CardEndingIn')} ${accountMask}`}
          testID={testID ?? 'payment-method-action-row-debit-card'}
          title={friendlyName ?? t('DebitCard')}
          titleStatusPill={titleStatusPill}
        />
      )
  }
}

export {PaymentMethodActionRow}
